<template lang="pug">
#bloco-infor-dados-py-ar
    .bloco-infor-dados-ar
        BlocoInformacaoSkeleton(:carregando='skeletonBlocoInforDados')
            BlocoInformacao(
                :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosNaoVisualizado")',
                :numero='totalContratosOriginacao.totalNaoVisualizado',
                @click.native='aplicarFiltroStatus(status[0], 0)',
                :class='[codigosStatusAtivo[0].removeStatus ? "bloco-infor-dados-ativo" : ""]'
            )
                template(slot='icone')
                    i.mdi.mdi-eye-off-outline

        BlocoInformacaoSkeleton(:carregando='skeletonBlocoInforDados')
            BlocoInformacao(
                :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosVisualizado")',
                :numero='totalContratosOriginacao.totalVisualizado',
                @click.native='aplicarFiltroStatus(status[1], 1)',
                :class='[codigosStatusAtivo[1].removeStatus ? "bloco-infor-dados-ativo" : ""]'
            )
                template(slot='icone')
                    i.mdi.mdi-eye-outline

        BlocoInformacaoSkeleton(:carregando='skeletonBlocoInforDados')
            BlocoInformacao(
                :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosEmCadastramento")',
                :numero='totalContratosOriginacao.totalEmCadastramento',
                @click.native='aplicarFiltroStatus(status[2], 2)',
                :class='[codigosStatusAtivo[2].removeStatus ? "bloco-infor-dados-ativo" : ""]'
            )
                template(slot='icone')
                    i.mdi.mdi-pen-plus

        BlocoInformacaoSkeleton(:carregando='skeletonBlocoInforDados')
            BlocoInformacao(
                :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosArquivado")',
                :numero='totalContratosOriginacao.totalArquivado',
                @click.native='aplicarFiltroStatus(status[4], 4)',
                :class='[codigosStatusAtivo[4].removeStatus ? "bloco-infor-dados-ativo" : ""]'
            )
                template(slot='icone')
                    i.mdi.mdi-archive

        BlocoInformacaoSkeleton(:carregando='skeletonBlocoInforDados')
            BlocoInformacao(
                :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosConcluido")',
                :numero='totalContratosOriginacao.totalConcluido',
                @click.native='aplicarFiltroStatus(status[3], 3)',
                :class='[codigosStatusAtivo[3].removeStatus ? "bloco-infor-dados-ativo" : ""]'
            )
                template(slot='icone')
                    i.mdi.mdi-check-circle-outline
</template>

<script>
import BlocoInformacao from '@/components/contratosOriginacao/EmpresaBlocoInformacao.vue';
import BlocoInformacaoSkeleton from '@/components/contratosOriginacao/EmpresaBlocoInformacaoSkeleton.vue';

export default {
    components: {
        BlocoInformacao,
        BlocoInformacaoSkeleton
    },
    mounted() {
        this.buscarStatus();
    },
    props: {
        totalContratosOriginacao: {
            type: Object,
            required: true
        },
        totalizador: {
            type: Number,
            required: true
        },
        skeletonBlocoInforDados: {
            type: Boolean,
            required: true
        },
        isBunge: {
            type: Boolean,
            required: true
        },
        codigosStatusAtivo: {
            type: Array,
            required: true
        },
        status: {
            type: Array,
            required: true
        }
    },
    methods: {
        aplicarFiltroStatus(status, indice) {
            this.$emit('emitFiltroStatus', status, indice);
        },
        async buscarStatus() {
            this.$emit('emitStatus', status);
        }
    }
};
</script>

<style lang="scss">
#bloco-infor-dados-py-ar {
    .bloco-infor-dados-ar {
        display: flex;
        justify-content: space-between;
        gap: 5px;
        width: 100%;
        flex-wrap: wrap;
        margin-top: 20px;
        & > div {
            flex-grow: 1;
        }
        #empresa-bloco-informacao {
            cursor: pointer;
            border: 1px solid #e1e1e1;

            &.bloco-infor-dados-ativo {
                border-color: var(--primary) !important;
            }
        }
    }
}
</style>
